import { Injectable } from '@angular/core';
import { EmailTemplate } from '../app.domain.models/email-template';
import { EmailTemplateRepository } from '../app.domain.repository/email-template.repository';
import { GenericEntityService } from '../core.utilidades/generic-entity.service';

@Injectable({
    providedIn: 'root',
})
export class EmailTemplateApiService extends EmailTemplateRepository implements GenericEntityService<EmailTemplate> { }
